export default {
    COMPACT: 'Compact',
    SUBCOMPACT: 'Subcompact',
    FULLSIZE: 'Full Size',
    MIDSIZE: 'Midsize',
    MINIVAN: 'Minivan',
    'FULLSIZE_CREW+COMPACT_CREW': 'Crew Cab',
    'FULLSIZE_EXTEND+COMPACT_EXTEND': 'Extended Cab',
    'FULLSIZE_REG+COMPACT_REG': 'Regular Cab',
};
